/** Ordered Kanban stages — ids are stable for API mapping later */

export const PIPELINE_STAGE_IDS = {
  SHORTLISTED: "shortlisted",
  CONTACTED: "contacted",
  NEGOTIATING: "negotiating",
  CONTRACTED: "contracted",
  CONFIRMED: "confirmed",
  REJECTED: "rejected",
};

export const PIPELINE_STAGES = [
  {
    id: PIPELINE_STAGE_IDS.SHORTLISTED,
    label: "Shortlisted",
    // Soft neutral lane — invite link not yet sent
    dotClass: "bg-[#9C9790]",
    desc: "Invite link not yet sent",
  },
  {
    id: PIPELINE_STAGE_IDS.CONTACTED,
    label: "Contacted",
    // Orange lane — invite link sent (email/DM) and awaiting influencer acceptance
    dotClass: "bg-[#F08A24]",
    desc: "Awaiting influencer acceptance",
  },
  {
    id: PIPELINE_STAGE_IDS.NEGOTIATING,
    label: "Negotiating",
    // Deep purple lane — pricing & deliverables
    dotClass: "bg-[#4C43B0]",
    desc: "Pricing & deliverables discussion",
  },
  {
    id: PIPELINE_STAGE_IDS.CONTRACTED,
    label: "Contracted",
    // Strong blue lane — contract being signed
    dotClass: "bg-[#1557A0]",
    desc: "Contract being signed",
  },
  {
    id: PIPELINE_STAGE_IDS.CONFIRMED,
    label: "Confirmed",
    // Confident green lane — ready to go live
    dotClass: "bg-[#1D9E75]",
    desc: "Ready to go live",
  },
  {
    id: PIPELINE_STAGE_IDS.REJECTED,
    label: "Rejected",
    // Red terminal lane — cannot be re-shortlisted for this campaign
    dotClass: "bg-[#D14343]",
    desc: "Removed or declined for this campaign",
  },
];

export const getStageIndex = (stageId) =>
  PIPELINE_STAGES.findIndex((s) => s.id === stageId);

export const getNextStageId = (currentStageId) => {
  const i = getStageIndex(currentStageId);
  if (i < 0 || i >= PIPELINE_STAGES.length - 1) return null;
  return PIPELINE_STAGES[i + 1].id;
};
